import { Tab } from "semantic-ui-react"

export function ControlledTab({panes, onChange, subPage}: {panes: Record<string, any>[], onChange:(activeItemString: string)=>void, subPage: string}){
    return <Tab
    onTabChange={(_, { activeIndex }) => {
        onChange(normalizeMenuItemName(panes[activeIndex as number].menuItem));
    }}
    panes={panes} activeIndex={panes.findIndex((f)=>compareMenuItemName(f.menuItem,subPage))} />
}

function normalizeMenuItemName(a: string) {
    return a.toLowerCase().replace(/ /g, "-");
}
  
function compareMenuItemName(a: string, b: string) {
    return normalizeMenuItemName(a) === normalizeMenuItemName(b);
}
